import * as Types from '../../../generated.types'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type UpdateStripeCompanyAccountMutationVariables = Types.Exact<{
  input: Types.UpdateStripeCompanyAccountInput
}>

export type UpdateStripeCompanyAccountMutation = {
  __typename?: 'Mutation'
  updateStripeCompanyAccount?: {
    __typename?: 'UpdateStripeCompanyAccountPayload'
    success: boolean
    organization?: { __typename?: 'Organization'; id: number } | null
    inputErrors: Array<{ __typename?: 'InputError'; argument: string; message: string }>
  } | null
}

export const UpdateStripeCompanyAccountDocument = `
    mutation UpdateStripeCompanyAccount($input: UpdateStripeCompanyAccountInput!) {
  updateStripeCompanyAccount(input: $input) {
    organization {
      id
    }
    inputErrors {
      argument
      message
    }
    success
  }
}
    `
export const useUpdateStripeCompanyAccountMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateStripeCompanyAccountMutation,
    TError,
    UpdateStripeCompanyAccountMutationVariables,
    TContext
  >
) =>
  useMutation<
    UpdateStripeCompanyAccountMutation,
    TError,
    UpdateStripeCompanyAccountMutationVariables,
    TContext
  >(
    ['UpdateStripeCompanyAccount'],
    (variables?: UpdateStripeCompanyAccountMutationVariables) =>
      fetchGql<UpdateStripeCompanyAccountMutation, UpdateStripeCompanyAccountMutationVariables>(
        UpdateStripeCompanyAccountDocument,
        variables
      )(),
    options
  )
